import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    audits: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_AUDIT_SELECT_IDS (store, ids) {
      store.audits.selectIds = ids
    },
    REMOVE_AUDIT_SELECT_IDS (store, ids) {
      store.audits.selectIds = store.audits.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_AUDIT_SELECT_ID (store, id) {
      store.audits.selectId = id
    },
    SET_AUDIT_FILTERS (store, filters) {
      store.audits.filters = filters
    },
    SET_AUDIT_PAGINATE (store, val) {
      store.audits.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getAudits: (store, getters) => {
      return store.audits.selectIds.map((id) => {
        return getters['entities/audits/find'](id)
      })
    },
    getAuditsFilters: (store, getters) => {
      return store.audits.filters
    },
    getAuditsPaginate: (store, getters) => {
      return store.audits.paginate
    },
    getAudit: (store, getters) => {
      return getters['entities/audits/find'](store.audits.selectId) || {}
    }
  },
  actions: {
    /*
    selectAudits
    */
    selectAudits ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAudits', filters)
      .then((response) => {
        commit('SET_AUDIT_FILTERS', filters)
        commit('SET_AUDIT_PAGINATE', response)
        commit('SET_AUDIT_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectAudits
    */
    refreshSelectAudits ({commit, dispatch, getters, state}) {
      return dispatch('selectAudits', getters.getAuditsFilters)
    },
    /*
    selectAudit
    */
    selectAudit ({commit, dispatch, getters, state}, id) {
      return dispatch('getAuditById', id)
      .then((response) => {
        commit('SET_AUDIT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getAudits
    */
    getAudits ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/audits`, {params: filters})
      .then((response) => {
        return dispatch('entities/audits/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.audits || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getAuditById
    */
    getAuditById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/audits/${id}`)
      .then((response) => {
        return dispatch('entities/audits/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.audits[0]
      })
    },
    /*
    createAudit
    */
    createAudit ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/audits`, data)
      .then((response) => {
        return dispatch('entities/audits/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.audits[0]
      })
    },
    /*
    updateAudit
    */
    updateAudit ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/audits/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/audits/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.audits[0]
      })
    },
    /*
    mergeAudits
    */
    mergeAudits ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/audits/merge`, data)
      .then((response) => {
        return dispatch('entities/audits/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.audits[0]
      })
    },
    /*
    deleteAudit
    */
    deleteAudit ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/audits/${id}`)
      .then((response) => {
        commit('REMOVE_AUDIT_SELECT_IDS', [id])
        dispatch('entities/audits/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Audit.js